/*
 * Acquisition capture into cart attributes (DT-38).
 *
 * On add-to-cart, copies the page URL's utm_* parameters onto the cart as
 * hidden `_acq_*` attributes; Shopify carries them onto the order, so the
 * campaign survives checkout, the Unzer return and refused analytics cookies.
 *
 * LEGAL — cleared by Eva (Rechtsabteilung) 2026-09-18, recorded on DT-38, for
 * exactly this behaviour. Runs regardless of cookie consent. Do NOT, without a
 * new ruling from Eva and the data team's OK:
 *   - add browser storage (localStorage / sessionStorage / cookies; § 25 TTDSG),
 *   - add click ids (gclid, fbclid, …) or anything person-level to ACQ_KEYS,
 *   - link these values across orders or keep them beyond the order.
 *
 * First touch wins: the cart is the memory. If it already carries an `_acq_*`
 * key, nothing is written. Pages without utm_source/utm_medium do nothing.
 */
(function () {
  'use strict';

  var ACQ_KEYS = {
    utm_source: '_acq_utm_source',
    utm_medium: '_acq_utm_medium',
    utm_campaign: '_acq_utm_campaign',
    utm_content: '_acq_utm_content',
    utm_term: '_acq_utm_term'
  };
  var TS_KEY = '_acq_landing_ts';
  var MAX_LEN = 255;
  var PREFIX = '_acq_';

  if (window.Shopify && (window.Shopify.designMode || window.Shopify.Checkout)) return;
  if (!window.fetch) return;

  function readParams() {
    var out = null, qs;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { return null; }
    for (var p in ACQ_KEYS) {
      if (!Object.prototype.hasOwnProperty.call(ACQ_KEYS, p)) continue;
      var v = qs.get(p);
      if (v === null) continue;
      v = String(v).replace(/[\x00-\x1f\x7f]/g, '').trim();
      // Empty values would look like real tags downstream; over-long ones are
      // dropped rather than truncated into a wrong campaign name.
      if (!v || v.length > MAX_LEN) continue;
      out = out || {};
      out[ACQ_KEYS[p]] = v;
    }
    if (!out || (!out._acq_utm_source && !out._acq_utm_medium)) return null;
    out[TS_KEY] = new Date().toISOString();
    return out;
  }

  var pending = readParams();
  if (!pending) return;

  var root = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var origFetch = window.fetch;

  // Stays null until the cart read answers; every write path refuses while it
  // is null, so a slow read can lose a capture but never overwrite one.
  var alreadyCaptured = null;
  var done = false;

  origFetch.call(window, root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (!cart) return;
      var attrs = cart.attributes || {};
      alreadyCaptured = false;
      for (var k in attrs) {
        if (k.indexOf(PREFIX) === 0 && attrs[k]) { alreadyCaptured = true; break; }
      }
    })
    .catch(function () {});

  // Runs only after a successful add, so the update lands on the cart the add
  // created instead of racing it, and a failed add (sold out) writes nothing.
  // /cart/update.js merges attributes, so __awc, unzer* etc. survive.
  function write() {
    if (done || alreadyCaptured !== false) return;
    done = true;
    origFetch.call(window, root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: pending })
    }).then(function (r) { if (!r.ok) done = false; }, function () { done = false; });
  }

  function isCartAdd(url) {
    try { return /\/cart\/add(\.js)?(\?|$)/.test(String(url)); } catch (e) { return false; }
  }

  // The theme's own request is returned untouched; the capture only observes it.
  window.fetch = function (input) {
    var request = origFetch.apply(this, arguments);
    try {
      if (isCartAdd(input && input.url ? input.url : input)) {
        request.then(function (r) { if (r.ok) write(); }, function () {});
      }
    } catch (e) {}
    return request;
  };

  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (isCartAdd(url)) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) write();
          });
        }
      } catch (e) {}
      return origOpen.apply(this, arguments);
    };
  }

  // A full-page form POST unloads before a fetch could land, so the values ride
  // along in the form; /cart/add accepts attributes[<key>].
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.action || !isCartAdd(form.action)) return;
    if (done || alreadyCaptured !== false) return;
    done = true;
    for (var k in pending) {
      if (!Object.prototype.hasOwnProperty.call(pending, k)) continue;
      if (form.querySelector('[name="attributes[' + k + ']"]')) continue;
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'attributes[' + k + ']';
      i.value = pending[k];
      form.appendChild(i);
    }
  }, true);
})();
